import { Injectable } from '@angular/core';

// One colour and one set of initials per person, read from the published avatar palette
@Injectable({
  providedIn: 'root'
})
export class AvatarService {
  private cache : Map<string, string> = new Map<string, string>();
  private count : number              = 0;

  colorFor ( key : string ) : string {
    return this.read(`--avatar-${ this.themeIndexFor(key) }`);
  }

  initialsFor ( name : string ) : string {
    const words = String(name == null ? '' : name)
      .split(/\s+/)
      .filter(word => !!word);

    if ( !words.length ) {
      return '?';
    }

    return words
      .slice(0, 2)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  }

  // a stable index into the palette, so one key always lands on the same colour
  themeIndexFor ( key : string ) : number {
    const count = this.paletteSize();

    return count
      ? this.hashToInt(key) % count
      : 0;
  }

  private hashToInt ( key : string ) : number {
    const value = String(key == null ? '' : key);

    let hash = 0;

    for ( let index = 0; index < value.length; index++ ) {
      hash = ( ( hash << 5 ) - hash ) + value.charCodeAt(index);
      hash |= 0;
    }

    return Math.abs(hash);
  }

  private paletteSize () : number {
    if ( !this.count ) {
      this.count = parseInt(this.read('--avatar-count'), 10) || 0;
    }

    return this.count;
  }

  // an empty read means the stylesheet is not in the document yet, so nothing is cached
  private read ( name : string ) : string {
    if ( !this.cache.has(name) ) {
      const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();

      if ( !value ) {
        return value;
      }

      this.cache.set(name, value);
    }

    return this.cache.get(name);
  }
}
